module.exports = __webpack_public_path__ + "img/almenu_gomb_palyazatok_aktiv.b75a3ac9.png";